var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoLi = function SvgIcoLi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M6.07 2.672v1.375c1.2-2.39 5.918-2.43 6.078 1.033l.004.182v6.075l-2.436.001v-4.86c0-3.374-3.512-2.457-3.642-.126l-.004.124v4.862H3.646V2.672zv1.375zm-3.646.16v8.506H0V2.831h2.424zM1.215 0a1.213 1.213 0 1 1 0 2.426 1.213 1.213 0 0 1 0-2.426"
  })));
};
export default SvgIcoLi;